import moment from 'moment';
import fetchWTO from './fetchWithTimeout';

export function checkHttpStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}

export function parseJSON(response) {
  return response.json();
}

export const Action = (type, payload) => ({
  type,
  payload,
  updatedOn: moment().toDate(),
});

class Api {
  static jsonService(url, method, data, token) {
    let options = { method };
    let headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'api-version': 2.0,
    };
    if (data) {
      options = { ...options, body: JSON.stringify(data) };
    }
    if (token) {
      headers = { ...headers, Authorization: token };
    }
    options = { ...options, headers };
    return new Promise((resolve, reject) => {
      fetchWTO(url, options)
        .then(parseJSON)
        .then(json => {
          if (json.Success) {
            if (json.Success === 'true') {
              resolve(json);
            } else {
              reject(json);
            }
          } else {
            resolve(json);
          }
        })
        .catch(error => {
          if (error instanceof Error) {
            reject('timeout'); // eslint-disable-line
          } else {
            reject(error);
          }
        });
    });
  }

  static htmlService(url) {
    return new Promise((resolve, reject) => {
      fetchWTO(url, {})
        .then(checkHttpStatus)
        .then(res => res.text())
        .then(html => resolve(html))
        .catch(err => reject(err));
    });
  }

  static encodedService(url, method, data) {
    const encodedData = Object.keys(data)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
      .join('&');
    return new Promise((resolve, reject) => {
      fetchWTO(url, {
        method,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: encodedData,
      })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then(json => resolve(json))
        .catch(err => reject(err));
    });
  }
}

export default Api;
